export default "__VITE_ASSET__0cpY_xdC__"